export default __webpack_public_path__ + "static/media/mustdo.bc47fa19.jpg";